module.exports = __webpack_public_path__ + "media/images/psp/globe-f866426d27dc008f01925659864c0845.svg";